export type Theme = "system" | "light" | "dark";

const KEY = "salesm8-agent.theme";

export function loadTheme(): Theme {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme: Theme) {
  if (theme === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", theme);
  try {
    if (theme === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {
    // Storage unavailable (private window): the choice lasts for this page only.
  }
}

export const nextTheme: Record<Theme, Theme> = { system: "light", light: "dark", dark: "system" };
export const themeLabel: Record<Theme, string> = { system: "Tema: system", light: "Tema: ljust", dark: "Tema: mörkt" };
